import React, { useEffect, useRef, useState, useContext } from "react"
import gsap from 'gsap'
// import moment from 'moment';

import NewHeader from "../components/layout/NewHeader"
import Modal from "../components/layout/modal"
import Predict from "../components/predictions/predict"
import Record from "../components/predictions/record"
import Aid from "../components/predictions/aid"
import { defPath, fetchPath } from '../config/defPath'
import { useTabsPredictions } from "../hooks/useTabsPredictions"
import { Controls } from "../components/layout/menu_help"
import useLocalStorage from "../hooks/useLocalData"
import { PopsController } from "../classes/popsController"
import Popups from "../components/layout/popup"
import ThemeContext from "../contexts/themeContext"

const MATCHES_URL = `${fetchPath}/aguila/loyalty/get-matches`
const RECORD_URL = `${fetchPath}/aguila/loyalty/get-matches-record`
const PREDICTION_POST_URL = `${fetchPath}/aguila/loyalty/send/predictions`
declare global {
  interface Window {
    moment: any
  }
}

export default function Predicciones() {
  const { toggleTab, getActiveClass, tagName } = useTabsPredictions()
  const [matchesList, setMatchesList] = useState<any>([])
  const [leagueActive, setLeagueActive] = useState<string | null>()
  const [leagueActiveHitory, setLeagueActiveHistory] = useState<string | null>()
  const [infoPoints, setInfoPoints] = useState<any>({});
  const [recordList, setRecordList] = useState<any>([])
  const [noMatches, setNoMatches] = useState<boolean>(false)
  const [noMatchesHistory, setNoMatchesHistory] = useState<boolean>(false)

  const menu = useRef<HTMLDivElement>(null)
  const menuIcon = useRef<HTMLDivElement>(null)
  const menuHeader = useRef<HTMLDivElement>(null)

  const selectRef = useRef(null);
  const selectHistoryRef = useRef(null);

  const theme = useContext(ThemeContext);

  const handleChange = () => {
    const selectedValue = selectRef.current.value;
    setLeagueActive(`${selectedValue}`);
  };

  const handleChangeHistory = () => {
    const selectedValue = selectHistoryRef.current.value;
    setLeagueActiveHistory(`${selectedValue}`)
  };


  useEffect(() => {
    getMatchesList(leagueActive)
  }, [leagueActive])
  
  useEffect(() => {
    getRecordList(leagueActiveHitory)
  }, [leagueActiveHitory])

  const handleClickOpenMenu = () => {
    if (menuIcon) {
      gsap.to(menuIcon.current, { x: theme === 'none' ? '100%' : '-100%', opacity: 0 })
      gsap.to(menu.current, { x: '0%', opacity: 1 })
      gsap.to(menuHeader.current, { overflow: 'visible' })

      window.dataLayer.push({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'Card',
        'event_label': 'Open menu - Predictions',
        'interaction': 'true',
        'component_name': 'Modo_Carrera_Predictions',
        'element_text': 'Menú',
      });
    }
  }

  const handleClickCloseMenu = () => {
    if (menuIcon) {
      gsap.to(menu.current, { x: theme === 'none' ? '100%' : '-100%', opacity: 0, overflowX: 'hidden' })
      gsap.to(menuIcon.current, { x: '0%', opacity: 1 })
      gsap.to(menuHeader.current, { overflow: 'hidden', delay: 1 })

      window.dataLayer.push({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'Card',
        'event_label': 'Close menu - Predictions',
        'interaction': 'true',
        'component_name': 'Modo_Carrera_Predictions',
        'element_text': 'Cerrar',
      });
    }
  }

  async function getMatchesList(id: string | null) {
    const url = id ? MATCHES_URL + `/${id}` : MATCHES_URL;
    try {
      const res = await fetch(url);
      const data: any = await res.json();
      if (data && data.matches.length > 0) {
        setMatchesList(data)
        statesCards()
        setNoMatches(false)
      } else {
        setNoMatches(true)
      }
      if(Object.keys(infoPoints).length === 0) setInfoPoints(data.points);
    } catch (error) { console.error(error); }
  }

  async function getRecordList(id?: string | null) {
    const url = id ? RECORD_URL + `/${id}` : RECORD_URL;
    try {
      const res = await fetch(url)
      const record: any = await res.json()
      if (record && record?.matches?.length > 0) {
        setRecordList(record)
        setNoMatchesHistory(false)
      } else {
        setNoMatchesHistory(true)
      }
    } catch (error) { console.error(error); }
  }

  function statesCards() {
    const cards = document.querySelectorAll(".ar__predictions__matches > div")

    cards.forEach((card: any) => {
      let gameTime = window.moment(card.getAttribute("data-date"))
      // let gameTime = window.moment("2023-04-25 09:12:00")
      let now = window.moment()

      let minutes = gameTime.diff(now, 'minutes')
      let hours = now.diff(gameTime, 'hour')

      let inputs = card?.querySelectorAll(".ar__predictions__match__score__scoreboard__row input")

      inputs.length > 0 && inputs.forEach((input: any) => {
        const dataInital = input.getAttribute("data-initial")
        if (dataInital) {
          input.value = dataInital
        }
      })

      if (hours >= 2) {
        const matchStatusText = card.querySelector(".live .ar__predictions__match__score__state")
        const scoreText = card.querySelector(".live .ar__predictions__match__score__bottom p")
        const img = card.querySelector(".live .ar__predictions__match__score__bottom__bg img")
        //mancha azul
        img?.setAttribute("src", `${window.origin}${defPath}/assets/images/predictions/bgFinal.svg`)

        if (scoreText) { scoreText.textContent = "Marcador final" }
        if (matchStatusText) {
          matchStatusText.classList.add("status")
          matchStatusText.textContent = "Finalizado"
        }
        card?.setAttribute("data-state", "finish")

        card?.classList.add("ar__predictions__match--finish")
        card?.classList.remove("ar__predictions__match--prediction")
        return
      }

      if (minutes <= 9) {
        card?.classList.add("ar__predictions__match--live")
        card?.classList.remove("ar__predictions__match--prediction")
        return
      }
    })
  }
  const { addItem } = useLocalStorage()

  const [loading, setLoading] = useState(false)

  async function handlePredictionPost(predictions: any) {
    const isError = document.querySelector(".error-message") as HTMLElement

    if (isError) {
      const parent = isError?.closest(".ar__predictions__match__score__scoreboard__box")
      const input = parent?.querySelector("input")
      input?.focus()
      return
    }


    if (!isError && predictions.length > 0) {

      if (!window.drupalSettings.user.uid) {
        // addItem('predicciones', predictions)
        new PopsController().open('predicciones')
        return
      }

      setLoading(true)

      await fetch(PREDICTION_POST_URL, {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(predictions)
      })
        .then(res => res.json())
        .then(data => {
          if (data[0].message === "SUCCESS") {
            getMatchesList(leagueActive)
            const btn = document.querySelector(".ar__predictions__save")
            btn?.classList.remove("showBtn")

            window.openAlert({
              title: 'Predicción guardada.',
            })

            if (data[0].popup) {
              setTimeout(() => {
                  window.openAlert({
                      title: `${data[0].popup}`,
                      time: 6000
                  })
              }, 6000)
            }

            predictions.forEach(((prediction: any) => {
              window.dataLayer.push({
                'event': 'GAEvent',
                'event_category': 'Content',
                'event_action': 'Button',
                'event_label': `${prediction.nameHome}_${prediction.nameAway} - ${prediction.league}`,
                'interaction': 'true',
                'component_name': 'Modo_Carrera_Predictions',
                'element_text': 'Guardar Marcadores',
              });
            }))
          }
        })
        .catch((error) => {
          console.error('Error:', error)
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }

  function sendOptionMenuDatalayer(e: any) {
    let tagName = e.currentTarget.querySelector("span")?.textContent

    tagName && window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': `${tagName}- Predictions`,
      'interaction': 'true',
      'component_name': 'Modo_Carrera_Predictions',
      'element_text': tagName,
    });
  }

  return (
    <>
      {/* Page HTML */}
      <section className={`ar__predictions ${theme === 'none' ? '' : 'america__cup'}`}>
        <Controls isStadium={false} />
        <NewHeader />
        <Modal />
        <Popups />

        <div className="ar__predictions__bg">
          {
            theme === 'none'
              ? <picture className="ar__predictions__bg">
                <source media="(min-width: 767px)" srcSet={`${defPath}/assets/images/predictions/bgDesk-op.jpg`} />
                <img src={`${defPath}/assets/images/predictions/bgMob_prediction-op.jpg`} alt="Background Predicciones" title="Background Predicciones" />
              </picture>
              : <picture className="ar__predictions__bg">
                <source media="(min-width: 767px)" srcSet={`${defPath}/assets/images/loader-bg-2.png`} />
                <img src={`${defPath}/assets/images/loader-bg-mobile-2.png`} alt="Background Predicciones" title="Background Predicciones" />
              </picture>
          }

        </div>

        {/* MENU MENU MENU */}
        <div className='ar__predictions__header' ref={menuHeader}>
          <h2 className={`subtitle_black ${tagName.length > 9 ? 'subtitle_black--medium' : 'subtitle_black--big'}`}>
            {tagName}
          </h2>

          <div className='ar__predictions__menuIcon' ref={menuIcon} onClick={handleClickOpenMenu}>
            <div className='ar__predictions__menu--icon'></div>
          </div>

          <div className='ar__predictions__menu' ref={menu} onClick={handleClickCloseMenu}>
            <div className='ar__predictions__closedMenu--icon'></div>
            <div className="tab__list">
              <li
                className={`tab__head tab__head--mob ${getActiveClass(1, "tab__head--active")}`}
                onClick={(e) => { toggleTab(1, "Predice tus marcadores"); sendOptionMenuDatalayer(e) }}
              >
                <span className="black_30 blueDark">{theme === 'none' ? 'Pronósticos' : 'Predecir'}</span>
              </li>

              <li
                className={`tab__head tab__head--mob ${getActiveClass(2, "tab__head--active")}`}
                onClick={(e) => { toggleTab(2, "Tus marcadores"); sendOptionMenuDatalayer(e) }}
              >
                <span className="black_30 blueDark">historial</span>
              </li>

              <li
                className={`tab__head tab__head--mob ${getActiveClass(3, "tab__head--active")}`}
                onClick={(e) => { toggleTab(3, "Puntuación"); sendOptionMenuDatalayer(e) }}
              >
                <span className="black_30 blueDark">{theme === 'none' ? 'Puntuación' : 'Más info'}</span>
              </li>

              {
                theme !== 'none'
                && <li
                  className={`tab__head tab__head--mob ${getActiveClass(4, "tab__head--active")}`}
                  onClick={(e) => { location.href = '/copa-america/predicciones' }}
                >
                  <span className="black_30 blueDark">Sube tus tapas</span>
                </li>
              }
            </div>
          </div>
        </div>

        <div className="ar__predictions__menuDesk">
          <div className="tab__list">
            <li
              className={`tab__head tab__head--desk ${getActiveClass(1, "tab__head--active")}`}
              onClick={(e) => { toggleTab(1, "Predice tus marcadores"); sendOptionMenuDatalayer(e) }}
            >
              <span className="black_30 blueDark">{theme === 'none' ? 'Pronósticos' : 'Predecir'}</span>
            </li>
            <li
              className={`tab__head tab__head--desk ${getActiveClass(2, "tab__head--active")}`}
              onClick={(e) => { toggleTab(2, "Tus marcadores"); sendOptionMenuDatalayer(e) }}
            >
              <span className="black_30 blueDark">historial</span>
            </li>
            <li
              className={`tab__head tab__head--desk ${getActiveClass(3, "tab__head--active")}`}
              onClick={(e) => { toggleTab(3, "Puntuación"); sendOptionMenuDatalayer(e) }}
            >
              <span className="black_30 blueDark">{theme === 'none' ? 'Puntuación' : 'Más info'}</span>
            </li>
            {
                theme !== 'none'
                && <li
                  className={`tab__head tab__head--desk ${getActiveClass(4, "tab__head--active")}`}
                  onClick={(e) => { location.href = '/copa-america/predicciones' }}
                >
                  <span className="black_30 blueDark">Sube tus tapas</span>
                </li>
              }
          </div>
        </div>

        <div className="ar__predictions__tabs">
          <div className={`tab__container ${tagName}`}>
            <div className={`tab__content predict ${getActiveClass(1, "tab__content--active")}`}>

              {
                matchesList?.matches?.length > 0
                  ? (<>
                    <div className="ar__predictions__filter">
                      <select ref={selectRef} className="ar__predictions__filter--select" name="ligas" id="ligas" onChange={handleChange}>
                        <option value="">Todas las Ligas</option>
                        {
                          matchesList?.leagues && matchesList?.leagues.length > 0 && matchesList?.leagues.map((league: any, index: number) => (
                            <option key={league.season_id} value={league.season_id}>{league.name}</option>
                          ))
                        }
                      </select>
                    </div>
                    {noMatches ? (
                      <div className='record__noContent' style={{ zIndex: "-2" }}>
                        <h3 className='record__noContent--title medium_45'>¡No hay partidos disponibles en este momento!</h3>
                      </div>
                    ) :
                      <>
                        {(leagueActive == 'femenino' || leagueActive == 'masculino') && <a href="/copa-aguila" className="ar__know-more">Saber más de la copa</a>}
                        <Predict matchesList={matchesList?.matches} handlePredictionPost={handlePredictionPost} loading={loading} />
                      </>
                    }
                  </>)
                  : (
                    <div className='record__noContent animate-fade-fetch'>
                      <h3 className='record__noContent--title medium_45'>lo sentimos, no tenemos predicciones activas</h3>
                      {theme === 'none' && <p className='record__noContent--text medium_30'>sin embargo, te invitamos a divertirte con nuestro futbolín mientras tanto.</p>}
                      <div className="record__noContent--buttonBox">
                        { theme === 'none'
                          ? <a className="newBottom--smallYellow" href="/estadio-aguila/instrucciones">Juega ahora</a>
                          : <a className="newBottom--smallYellow" href="/copa-america/predicciones">Predecir camisetas</a>
                        }
                      </div>
                    </div>
                  )
              }
            </div>
            <div className={`tab__content record ${getActiveClass(2, "tab__content--active")}`}>

              {
                recordList?.matches?.length > 0
                  ? (<>
                    <div className="ar__predictions__filter">
                      <select ref={selectHistoryRef} className="ar__predictions__filter--select" name="ligas" id="ligas" onChange={handleChangeHistory}>
                        <option value="">Todas las Ligas</option>
                        {
                          recordList?.leagues?.length > 0 && recordList?.leagues.map((league: any, index: number) => (
                            <option key={league.season_id} value={league.season_id}>{league.name}</option>
                          ))
                        }
                      </select>
                    </div>
                    {noMatchesHistory ? (
                      <div className='record__noContent' style={{zIndex: "-2"}}>
                        <h3 className='record__noContent--title medium_45'>¡No hay partidos disponibles en este momento!</h3>
                        {/* <p className='record__noContent--text medium_30'>Adivina los resultados y acumula puntos que podrás redimir por premios</p> */}
                      </div>
                    ) : 
                      <Record recordList={recordList?.matches} />
                    }
                  </>)
                  : (
                    <div className='record__noContent animate-fade'>
                      <h3 className='record__noContent--title medium_45'>¡Demuestra todo lo que sabes de fútbol!</h3>
                      <p className='record__noContent--text medium_30'>Adivina los resultados y acumula puntos que podrás redimir por premios</p>
                      <div className="record__noContent--buttonBox">
                        <div className="newBottom--smallYellow" onClick={() => toggleTab(1, "PREDICE TUS MARCADORES")}>{theme === 'none' ? 'Juega ahora' : 'Ir a predecir'}</div>
                      </div>
                    </div>
                  )
              }
            </div>
            <div className={`tab__content info ${getActiveClass(3, "tab__content--active")}`}>
              <Aid points={infoPoints}/>
            </div>
          </div>
        </div>

      </section>
    </>
  )
}
